import type { SxProps, Theme } from '@portals/core/src/themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    pill: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(2),
      transition: '0.3s',
      '&.MuiChip-root svg': {
        transition: '0.3s',
      },
      '.MuiChip-deleteIcon': { fontSize: 'inherit', marginRight: '0' },
      '.MuiChip-label': { paddingLeft: 0, transition: '0.3s' },
      '&.MuiChip-root.Mui-focusVisible, &.MuiChip-root:focus, &.MuiChip-root:focus-visible': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.action.focus,
        boxShadow: `inset 0px 0px 0px 1px ${theme.palette.action.focus}`,
        '&.MuiChip-root svg': {
          fill: theme.palette.secondary.contrastText,
        },
      },
    },
    count: {
      position: 'relative',
      top: theme.spacing(1),
      color: theme.palette.text.primary,
    },
  };
};
